export default __webpack_public_path__ + "static/media/RebaseMessage.4ac6bf05.svg";